import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { productsAPI } from '../services/api';
import '../styles/UserDashboard.css';

const UserDashboard = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [myProducts, setMyProducts] = useState([]);
  const [stats, setStats] = useState({ total: 0, active: 0, pending: 0, sold: 0 });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMyProducts();
  }, []);

  const fetchMyProducts = async () => {
    try {
      const response = await productsAPI.getUserProducts();
      // La réponse peut être un tableau ou un objet paginé { products, pagination }
      const data = response.data;
      const products = Array.isArray(data) ? data : (data.products || []);
      setMyProducts(products);

      // Calculer les statistiques
      const total = products.length;
      const active = products.filter(p => p.status === 'active').length;
      const pending = products.filter(p => p.status === 'pending').length;
      const sold = products.filter(p => p.status === 'sold').length;
      setStats({ total, active, pending, sold });

      setLoading(false);
    } catch (err) {
      console.error('Erreur:', err);
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">{t('common.loading')}</div>;

  return (
    <div className="user-dashboard">
      <div className="dashboard-header">
        <h1>{t('dashboard.title')}</h1>
        <p>{t('dashboard.welcome', { name: user?.username })}</p>
      </div>

      {/* Statistiques utilisateur */}
      <div className="stats-grid">
        <div className="stat-card">
          <h3>{t('dashboard.myProducts')}</h3>
          <p className="stat-number">{stats.total}</p>
        </div>
        <div className="stat-card">
          <h3>{t('dashboard.onSale')}</h3>
          <p className="stat-number">{stats.active}</p>
        </div>
        <div className="stat-card">
          <h3>{t('dashboard.pending')}</h3>
          <p className="stat-number">{stats.pending}</p>
        </div>
        <div className="stat-card">
          <h3>{t('dashboard.sold')}</h3>
          <p className="stat-number">{stats.sold}</p>
        </div>
      </div>

      {/* Actions rapides */}
      <div className="quick-actions">
        <h2>{t('dashboard.quickActions')}</h2>
        <div className="action-buttons">
          <button onClick={() => navigate('/create-product')} className="action-btn primary">
            {t('dashboard.sellItem')}
          </button>
          <button onClick={() => navigate('/my-products')} className="action-btn">
            {t('dashboard.viewProducts')}
          </button>
          <button onClick={() => navigate('/favorites')} className="action-btn">
            {t('dashboard.myFavorites')}
          </button>
          <button onClick={() => navigate('/')} className="action-btn">
            {t('dashboard.browseItems')}
          </button>
        </div>
      </div>

      {/* Mes articles recents */}
      <div className="recent-events">
        <h2>{t('dashboard.recentProducts')}</h2>
        {myProducts.length === 0 ? (
          <div className="empty-state">
            <p>{t('dashboard.noProducts')}</p>
            <button onClick={() => navigate('/create-product')} className="create-btn">
              {t('dashboard.firstProduct')}
            </button>
          </div>
        ) : (
          <div className="events-grid">
            {myProducts.slice(0, 6).map(product => (
              <div key={product.id} className="event-card">
                <h3>{product.title}</h3>
                <p className="event-date">
                  {parseFloat(product.price).toFixed(2)} CHF
                </p>
                <p className="event-location">{t('dashboard.sizeLabel', { size: product.size })}</p>
                <div className="event-footer">
                  <span className={`status-badge ${product.status}`}>
                    {product.status === 'active' ? t('status.active') :
                     product.status === 'sold' ? t('status.sold') :
                     product.status === 'pending' ? t('status.pending') : product.status}
                  </span>
                  <button
                    onClick={() => navigate(`/product/${product.id}`)}
                    className="view-btn"
                  >
                    {t('common.view')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDashboard;
